import React from "react";
import { Grid, Switch, Typography } from "@mui/material";

function NotificationPreferences({ formData, setFormData }) {
	return (
		<Grid container alignItems="center" mt={2} justifyContent={"space-evenly"}>
			<Grid item xs={12} sm={4} container alignItems="center">
				<Switch
					checked={formData.notification.Email}
					onChange={() =>
						setFormData({
							...formData,
							notification: {
								...formData.notification,
								Email: !formData.notification.Email,
							},
						})
					}
				/>
				<Typography variant="body2">Email Notification</Typography>
			</Grid>
			<Grid item xs={12} sm={4} container alignItems="center">
				<Switch
					checked={formData.notification.WA}
					onChange={() =>
						setFormData({
							...formData,
							notification: {
								...formData.notification,
								WA: !formData.notification.WA,
							},
						})
					}
				/>
				<Typography variant="body2">WhatsApp Notification</Typography>
			</Grid>
			<Grid item xs={12} sm={4} container alignItems="center">
				<Switch
					checked={formData.notification.SMS}
					onChange={() =>
						setFormData({
							...formData,
							notification: {
								...formData.notification,
								SMS: !formData.notification.SMS,
							},
						})
					}
				/>
				<Typography variant="body2">SMS Notification</Typography>
			</Grid>
		</Grid>
	);
}

export default NotificationPreferences;
